import React from 'react';
import Link from 'gatsby-link';
import { Container, Image } from 'semantic-ui-react';
import heroImage from '../../images/transportation-2.jpg';

import './transportation-page.scss'

const heroStyles = {
  background: `
    url('${heroImage}')`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',

};

const TransportationPage = () => (
  <div>
    {/* Hero */}

    <div className="transportation-page">
    <div className="transportation-page__hero" style={heroStyles}/>
    <Container className="transportation-page__container">

      <h1 className="transportation-page__headline">Transportation Details</h1>


        <h3>From Airport</h3>
      <p>For information about transportation options from the airport visit their <a href="https://gspairport.com/hire-ground-transportation/" target="_blank">ground transportation page</a>.</p>

      <h3>Walking</h3>
      <p>There are many restaurants and attractions within easy walking distance of the conference venue.</p>

      <h3>Driving</h3>
        <p>If you are driving to Greenville or renting a car, please see <a target="_blank" href="https://www.visitgreenvillesc.com/travel-info/getting-around/downtown-parking/">here</a> for downtown parking options.  The hotel also has valet and self-parking available.</p>

      <h3>Downtown Trolley Service</h3>
        <p>Greenville has a FREE downtown trolley service!  The trolley’s hours of operation, route map, and tracker app are available <a target="_blank" href="https://www.visitgreenvillesc.com/travel-info/getting-around/downtown-trolley/">here</a>.</p>

      <h3>Greenlink Bus System</h3>
        <p>In addition to the free downtown trolley, Greenville has an affordable bus transit system with routes around the county.  For routes, schedules, and fares visit their <a target="_blank" href="http://greenvillesc.gov/151/Greenlink-Transit">website</a>.</p>

      <h3>Rideshare</h3>
        <p><a target="_blank" href="https://www.uber.com/cities/greenville-sc/">Uber</a> and <a target="_blank" href="https://www.lyft.com/cities/greenville-sc">Lyft</a> are available in Greenville.  Visit their websites for information on fare estimates and how to download the apps.</p>

      <h3>Bicycle Rentals</h3>
        <p>Interested in cycling around the city?  Rent a bicycle from <a target="_blank" href="https://www.visitgreenvillesc.com/listing/greenville-b-cycle/6269/">Greenville B-Cycle</a> or <a target="_blank" href="https://www.visitgreenvillesc.com/listing/reedy-rides/6151/">Reedy Rides</a>.</p>
    </Container>

    </div>


    {/* Footer */}
  </div>
)

export default TransportationPage;



// WEBPACK FOOTER //
// ./src/pages/transportation/index.js